// extracted by mini-css-extract-plugin
module.exports = {"navLink":"A3","borderLink":"A4","signupButton":"A5","navLinkWhileSearching":"A6"};